import { z } from 'zod';
/**
 * Check findings of module 50 (spec 50 §4.4, S50-1): the value sets, the
 * built-in system check codes with their default severities (proposed
 * defaults, spec 50 §9 Q2) and the shape of each code's `data` placeholders.
 * The API validates what it stores against these; the web translates
 * `review.finding.<code>` with the same placeholders.
 */
export const FINDING_SOURCES = ['system', 'ai_reviewer'];
export const FINDING_SEVERITIES = ['info', 'warning', 'blocking'];
export const SYSTEM_CHECK_CODES = ['missing_media', 'missing_localization', 'text_too_long', 'media_overused', 'people_without_release', 'media_aspect_mismatch', 'media_low_resolution'];
export const SYSTEM_CHECK_SEVERITIES = {
    missing_media: 'blocking',
    missing_localization: 'blocking',
    text_too_long: 'blocking',
    media_overused: 'warning',
    people_without_release: 'blocking',
    media_aspect_mismatch: 'warning',
    media_low_resolution: 'warning',
};
const uuid = z.uuid();
export const CHECK_FINDING_DATA_SCHEMAS = {
    missing_media: z.object({ variant_id: uuid.nullable(), format: z.string().nullable() }).strict(),
    missing_localization: z.object({ publication_id: uuid, localization_id: uuid, language: z.string() }).strict(),
    text_too_long: z
        .object({
        localization_id: uuid,
        language: z.string(),
        platform: z.enum(['instagram', 'facebook']),
        field: z.enum(['caption', 'hashtags']),
        limit: z.number().int().nonnegative(),
        actual: z.number().int().nonnegative(),
    })
        .strict(),
    media_overused: z.object({ asset_id: uuid, usage_count: z.number().int().nonnegative(), window_days: z.number().int().positive() }).strict(),
    people_without_release: z.object({ asset_id: uuid, variant_id: uuid }).strict(),
    /** The used part of the photo (after its crop) in px; spec 40 §4.5a. */
    media_aspect_mismatch: z.object({ asset_id: uuid, variant_id: uuid, format: z.string(), width: z.number().int().positive(), height: z.number().int().positive() }).strict(),
    media_low_resolution: z.object({ asset_id: uuid, variant_id: uuid, format: z.string(), width: z.number().int().positive(), height: z.number().int().positive() }).strict(),
};
export function isSystemCheckCode(value) {
    return typeof value === 'string' && SYSTEM_CHECK_CODES.includes(value);
}
/** Filter of `GET …/check-findings`: open (default), resolved or all. */
export const FINDING_STATES = ['open', 'resolved', 'all'];
//# sourceMappingURL=check-codes.js.map